import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import "./index.css";
import App from "./app/App";

// Suppress FloatingUI aria-hidden console warning (known issue with Material Tailwind Dialog)
const originalError = console.error;
console.error = (...args: unknown[]) => {
	const message = args[0];
	if (typeof message === "string" && message.includes("aria-hidden")) {
		return;
	}
	originalError.apply(console, args);
};

createRoot(document.getElementById("root")!).render(
	<StrictMode>
		<App />
	</StrictMode>
);
